/**
 * hospitalApi — talks to the hospital endpoints with whichever token is on hand:
 * a hospital staff token when signed in through /hospital/login, otherwise the
 * platform admin token (a Super Admin can open any hospital).
 */
import { getToken } from '@/lib/authToken';

const API_URL = process.env.REACT_APP_BACKEND_URL;
export const HOSPITAL_TOKEN_KEY = 'hospital_token';

export const hospitalToken = () => {
  try {
    return localStorage.getItem(HOSPITAL_TOKEN_KEY) || '';
  } catch (_e) {
    return '';
  }
};

export const hospitalApi = async (path, options = {}) => {
  const token = hospitalToken() || getToken();
  const r = await fetch(`${API_URL}/api${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });
  const body = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(body.detail || 'Something went wrong');
  return body;
};

export const ROLE_LABELS = {
  hospital_admin: 'Hospital Admin',
  doctor: 'Doctor',
  nurse: 'Nurse',
  receptionist: 'Receptionist',
  lab_technician: 'Lab Technician',
  pharmacist: 'Pharmacist',
  support_staff: 'Support Staff',
};

export const TYPE_LABELS = {
  clinic: 'Clinic',
  hospital: 'Hospital',
  specialist_centre: 'Specialist Centre',
};

export const STATUS_TONE = {
  scheduled: 'bg-sky-50 text-sky-700 border-sky-200',
  in_progress: 'bg-amber-50 text-amber-700 border-amber-200',
  completed: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  cancelled: 'bg-slate-100 text-slate-500 border-slate-200',
  paid: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  partial: 'bg-amber-50 text-amber-700 border-amber-200',
  waived: 'bg-indigo-50 text-indigo-700 border-indigo-200',
  unpaid: 'bg-rose-50 text-rose-700 border-rose-200',
};

export default hospitalApi;
